import { useState } from "react";

export function Login({ message, onLogin }: { message?: string; onLogin: (password: string) => Promise<void> }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  return (
    <main className="login-shell">
      <form
        className="login-panel"
        onSubmit={(event) => {
          event.preventDefault();
          onLogin(password).catch(() => setError("Wrong password."));
        }}
      >
        <h1 className="login-title">Wooten</h1>
        <p className="login-subtitle">Comfort controls</p>
        {message ? <p className="form-note">{message}</p> : null}
        <input
          autoFocus
          type="password"
          value={password}
          placeholder="Password"
          onChange={(event) => setPassword(event.target.value)}
        />
        <button type="submit">Unlock</button>
        {error ? <p className="form-error">{error}</p> : null}
      </form>
    </main>
  );
}
